<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <!--<div class="ir-btn th-btn-normal" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>-->
    </div>
    <div class="ir-line-content">
      <span
        >{{ 'templates.template-list' | translate }} <strong>({{ models?.length }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>

<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <div class="ir-section--list th-section--admin">
    <div class="ir-line ir-line-title">
      <div class="ir-line--right">
        <button
          class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right"
          (click)="gotoCreateTemplatePage()"
        >
          <span>{{ addText || 'templates.add-template' | translate }}</span>
        </button>
      </div>
      <div class="ir-line-content">
        <span>{{ contentText || 'templates.templates' | translate }}</span>
      </div>
    </div>
    <inspection-model-list-table
      [models]="models"
      (toggleSelectInspectionModel)="openModel($event)"
      [query]="query"
    ></inspection-model-list-table>
  </div>
</div>
